import { useConfirmAction } from '@/composables/useConfirmAction.js';

export default {
  install(app) {
    const confirmAction = useConfirmAction();
    
    // Make available as this.$confirmAction in Options API components
    app.config.globalProperties.$confirmAction = confirmAction;
    
    // Make available as app.config.globalProperties.$confirmAction for programmatic access
    app.provide('confirmAction', confirmAction);
    
    // Also make it available globally on the window object for non-Vue usage
    if (typeof window !== 'undefined') {
      window.confirmAction = confirmAction.confirmAction;
      window.confirmDanger = confirmAction.confirmDanger;
      window.confirmWarning = confirmAction.confirmWarning;
      window.confirmInfo = confirmAction.confirmInfo;
      window.confirmActionWithUrl = confirmAction.confirmActionWithUrl;
    }
  }
};